import { useMemo, useState } from "react";
import { welfareCollections, welfareTabs } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function WelfareSection() {
  const [tab, setTab] = useState(welfareTabs[0]);

  const list = useMemo(() => {
    if (tab === "全部合辑") return welfareCollections;
    return welfareCollections.filter((item) => item.category === tab);
  }, [tab]);

  return (
    <section id="welfare" className="py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <SectionHeading
          eyebrow="Collections"
          title="网红福利视频合辑"
          desc="不想追完整场直播的时候，可以按主题浏览合辑。每份合辑都把同一类型的高能片段集中在一起，并保留原场次日期，随时能回到完整回看。"
        />

        <div
          className="mb-8 inline-flex flex-wrap gap-1 rounded-full bg-secondary-100 p-1"
          role="tablist"
          aria-label="合辑分类"
          data-reveal
        >
          {welfareTabs.map((item) => {
            const active = item === tab;
            return (
              <button
                key={item}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => setTab(item)}
                className={`rounded-full px-3.5 py-1.5 text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  active
                    ? "bg-background-50 text-primary-700 font-medium"
                    : "text-secondary-900 hover:text-primary-700"
                }`}
              >
                {item}
              </button>
            );
          })}
        </div>

        {list.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center" data-reveal>
            <p className="text-sm text-foreground-700">
              该分类下的合辑正在整理中，先看看其他主题吧。
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {list.map((item) => (
              <article
                key={item.id}
                data-reveal
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
              >
                <div className="relative w-full aspect-[16/9] overflow-hidden">
                  <img
                    src={item.cover}
                    alt={`${item.title} 合辑封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                    {item.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-3 text-[11px] md:text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-stack-line" />
                      {item.count} 条片段
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" />
                      {item.duration}
                    </span>
                  </div>
                  <p className="mt-3 text-xs md:text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}